// @generated — do not edit manually. Run `npm run generate` to regenerate.
// Pre-computed hex values for React Native (OKLCH → sRGB gamut-mapped → hex).

import type { ThemeColors, ThemePresetColors, ThemePresetId, SurfaceScopes, ThemeSpacingNumeric, ThemeBorderRadiusNumeric } from './types.js';

export const BASE_LIGHT_HEX: ThemeColors = {
  surface0: '#f2f1ef',
  surface0Hover: '#eae9e6',
  surface0Active: '#e3e1dd',
  surface0Highlight: '#eeebe7',
  surface1: '#f2f1ef',
  surface1Hover: '#eae9e6',
  surface1Active: '#e3e1dd',
  surface1Highlight: '#eeebe7',
  surface2: '#ffffff',
  surface2Hover: '#f7f7f7',
  surface2Active: '#f0f0f0',
  surface2Highlight: '#f6f5f4',
  surface3: '#ffffff',
  surface3Hover: '#f7f7f7',
  surface3Active: '#f0f0f0',
  surface3Highlight: '#f6f5f4',
  surface4: '#fbfaf8',
  surface4Hover: '#f5f3f0',
  surface4Active: '#eeede9',
  surface4Highlight: '#f4f1ed',
  fg: '#0a0a0a',
  fgSecondary: '#5d5d5d',
  fgTertiary: '#717171',
  fgDisabled: '#989898',
  fgInverse: '#fafafa',
  fgLink: '#171717',
  fgSuccess: '#008a39',
  fgWarning: '#9e6300',
  fgError: '#ef4343',
  borderSubtle: '#dedede',
  borderDefault: '#cccccc',
  borderMainContent: '#d6d6d6',
  borderSuccess: '#59b47d',
  borderWarning: '#d1a84b',
  borderError: '#dc655f',
  accent: '#f5f5f5',
  accentForeground: '#171717',
  accentHover: '#e5e5e5',
  accentActive: '#e7e4e5',
  accentSubtle: '#f5f3f0',
  accentMuted: '#f7f7f4',
  accentBorder: '#d0cec7',
  ctaBg: '#0a0a0a',
  ctaFg: '#fafafa',
  ctaBgHover: '#222222',
  ctaBgActive: '#333333',
  ctaBorder: '#0a0a0a',
  sidebarAccent: '#f5f5f5',
  sidebarAccentForeground: '#171717',
  sidebarHover: '#f2f2f2',
  tabBg: '#e5e4e1',
  tabBgHover: '#dedcd9',
  tabOutline: '#c7c7c7',
  inputBg: '#ffffff',
  inputBorder: '#dedede',
  inputBorderHover: '#cccccc',
  inputBorderFocus: '#8f8f8f',
  inputBorderError: '#ef4343',
  inputBorderActive: '#bfbfbf',
  inputBorderHighlight: '#d1cec7',
  inputBgActive: '#f7f7f7',
  inputBgHighlight: '#f8f8f6',
  inputBgDisabled: '#f5f5f5',
  inputPlaceholder: '#8f8f8f',
  bgSuccess: '#cef9dc',
  bgWarning: '#ffecc1',
  bgError: '#ffe0dc',
  contentPreviewBg: '#dfdedc',
  contentPreviewFg: '#555555',
  contentPreviewBorder: '#cecdcc',
};

export const BASE_DARK_HEX: ThemeColors = {
  surface0: '#242424',
  surface0Hover: '#282828',
  surface0Active: '#2e2e2e',
  surface0Highlight: '#2a2a2a',
  surface1: '#252525',
  surface1Hover: '#2e2e2e',
  surface1Active: '#363636',
  surface1Highlight: '#303030',
  surface2: '#2e2e2e',
  surface2Hover: '#383838',
  surface2Active: '#404040',
  surface2Highlight: '#3b3b3b',
  surface3: '#2a2a2a',
  surface3Hover: '#333333',
  surface3Active: '#3b3b3b',
  surface3Highlight: '#363636',
  surface4: '#333333',
  surface4Hover: '#3d3d3d',
  surface4Active: '#454545',
  surface4Highlight: '#404040',
  fg: '#e5e5e5',
  fgSecondary: '#a3a3a3',
  fgTertiary: '#808080',
  fgDisabled: '#5d5d5d',
  fgInverse: '#171717',
  fgLink: '#fafafa',
  fgSuccess: '#21c45d',
  fgWarning: '#f59f0b',
  fgError: '#e24946',
  borderSubtle: '#333333',
  borderDefault: '#404040',
  borderMainContent: '#2b2b2b',
  borderSuccess: '#2a7449',
  borderWarning: '#8c6c1f',
  borderError: '#8c3432',
  accent: '#1a1a1a',
  accentForeground: '#e5e5e5',
  accentHover: '#262626',
  accentActive: '#171516',
  accentSubtle: '#12110f',
  accentMuted: '#0c0b0a',
  accentBorder: '#3c3a35',
  ctaBg: '#fafafa',
  ctaFg: '#0a0a0a',
  ctaBgHover: '#dedede',
  ctaBgActive: '#c4c4c4',
  ctaBorder: '#fafafa',
  sidebarAccent: '#1a1a1a',
  sidebarAccentForeground: '#e5e5e5',
  sidebarHover: '#171717',
  tabBg: '#2e2e2e',
  tabBgHover: '#383838',
  tabOutline: '#4c4c4c',
  inputBg: '#262626',
  inputBorder: '#383838',
  inputBorderHover: '#474747',
  inputBorderFocus: '#565656',
  inputBorderError: '#cf2f2f',
  inputBorderActive: '#525252',
  inputBorderHighlight: '#4c4c4c',
  inputBgActive: '#2e2e2e',
  inputBgHighlight: '#2b2b2b',
  inputBgDisabled: '#212121',
  inputPlaceholder: '#7a7a7a',
  bgSuccess: '#092012',
  bgWarning: '#251b05',
  bgError: '#291412',
  contentPreviewBg: '#333333',
  contentPreviewFg: '#a3a3a3',
  contentPreviewBorder: '#404040',
};

export const BASE_LIGHT_EXTENDED_HEX: Partial<ThemePresetColors> = {
  background: '#f2f1ef',
  panelBackground: '#f2f1ef',
  mainPanelBackground: '#f2f1ef',
  ring: '#0a0a0a',
  overlay: '#00000080',
  surfaceGlass: '#fbfaf8bf',
  skeleton: '#e4e4e4',
};

export const BASE_DARK_EXTENDED_HEX: Partial<ThemePresetColors> = {
  background: '#242424',
  panelBackground: '#252525',
  mainPanelBackground: '#252525',
  ring: '#e5e5e5',
  overlay: '#00000099',
  surfaceGlass: '#161614bf',
  skeleton: '#262626',
};

export const SURFACE_SCOPES_LIGHT_HEX: SurfaceScopes = {
  '0': {
    fg: '#0a0a0a',
    fgSecondary: '#5d5d5d',
    fgTertiary: '#717171',
    fgDisabled: '#989898',
    inputBg: '#ffffff',
    inputBorder: '#d9d9d9',
    inputBorderHover: '#c7c7c7',
    inputBorderFocus: '#c7c7c7',
    inputBorderError: '#ef4343',
    inputBorderActive: '#bababa',
    inputBorderHighlight: '#ccc9c1',
    inputBgActive: '#f7f7f7',
    inputBgHighlight: '#f8f8f6',
    inputBgDisabled: '#f2f2f2',
    inputPlaceholder: '#8f8f8f',
    tabBg: '#e5e4e1',
    tabBgHover: '#dedcd9',
    tabOutline: '#c7c7c7',
    borderSubtle: '#dedede',
    borderDefault: '#cccccc',
    ctaBg: '#0a0a0a',
    ctaFg: '#fafafa',
    ctaBgHover: '#222222',
    ctaBgActive: '#333333',
    ctaBorder: '#0a0a0a',
  },
  '1': {
    fg: '#0a0a0a',
    fgSecondary: '#5d5d5d',
    fgTertiary: '#717171',
    fgDisabled: '#989898',
    inputBg: '#ffffff',
    inputBorder: '#d9d9d9',
    inputBorderHover: '#c7c7c7',
    inputBorderFocus: '#c7c7c7',
    inputBorderError: '#ef4343',
    inputBorderActive: '#bababa',
    inputBorderHighlight: '#ccc9c1',
    inputBgActive: '#f7f7f7',
    inputBgHighlight: '#f8f8f6',
    inputBgDisabled: '#f2f2f2',
    inputPlaceholder: '#8f8f8f',
    tabBg: '#e5e4e1',
    tabBgHover: '#dedcd9',
    tabOutline: '#c7c7c7',
    borderSubtle: '#dedede',
    borderDefault: '#cccccc',
    ctaBg: '#121212',
    ctaFg: '#fafafa',
    ctaBgHover: '#292929',
    ctaBgActive: '#3a3a3a',
    ctaBorder: '#121212',
  },
  '2': {
    fg: '#0a0a0a',
    fgSecondary: '#5d5d5d',
    fgTertiary: '#717171',
    fgDisabled: '#989898',
    inputBg: '#fcfcfc',
    inputBorder: '#d6d6d6',
    inputBorderHover: '#c4c4c4',
    inputBorderFocus: '#c4c4c4',
    inputBorderError: '#ef4343',
    inputBorderActive: '#b7b7b7',
    inputBorderHighlight: '#cac6be',
    inputBgActive: '#f5f5f5',
    inputBgHighlight: '#f6f5f3',
    inputBgDisabled: '#f0f0f0',
    inputPlaceholder: '#8f8f8f',
    tabBg: '#dedede',
    tabBgHover: '#d6d6d6',
    tabOutline: '#c7c7c7',
    borderSubtle: '#dbdbdb',
    borderDefault: '#c9c9c9',
    ctaBg: '#1b1b1b',
    ctaFg: '#fafafa',
    ctaBgHover: '#333333',
    ctaBgActive: '#454545',
    ctaBorder: '#1b1b1b',
  },
  '3': {
    fg: '#0a0a0a',
    fgSecondary: '#5d5d5d',
    fgTertiary: '#717171',
    fgDisabled: '#989898',
    inputBg: '#f5f5f5',
    inputBorder: '#d1d1d1',
    inputBorderHover: '#bfbfbf',
    inputBorderFocus: '#bfbfbf',
    inputBorderError: '#ef4343',
    inputBorderActive: '#b2b2b2',
    inputBorderHighlight: '#c6c1b9',
    inputBgActive: '#ededed',
    inputBgHighlight: '#f2f1ed',
    inputBgDisabled: '#ededed',
    inputPlaceholder: '#8f8f8f',
    tabBg: '#f0f0f0',
    tabBgHover: '#e8e8e8',
    tabOutline: '#c7c7c7',
    borderSubtle: '#d9d9d9',
    borderDefault: '#c7c7c7',
    ctaBg: '#242424',
    ctaFg: '#fafafa',
    ctaBgHover: '#3d3d3d',
    ctaBgActive: '#505050',
    ctaBorder: '#242424',
  },
  '4': {
    fg: '#0a0a0a',
    fgSecondary: '#5d5d5d',
    fgTertiary: '#717171',
    fgDisabled: '#989898',
    inputBg: '#f5f5f5',
    inputBorder: '#d1d1d1',
    inputBorderHover: '#bfbfbf',
    inputBorderFocus: '#bfbfbf',
    inputBorderError: '#ef4343',
    inputBorderActive: '#b2b2b2',
    inputBorderHighlight: '#c6c1b9',
    inputBgActive: '#ededed',
    inputBgHighlight: '#f2f1ed',
    inputBgDisabled: '#ededed',
    inputPlaceholder: '#8f8f8f',
    tabBg: '#f0f0f0',
    tabBgHover: '#e8e8e8',
    tabOutline: '#c7c7c7',
    borderSubtle: '#d9d9d9',
    borderDefault: '#c7c7c7',
    ctaBg: '#2e2e2e',
    ctaFg: '#fafafa',
    ctaBgHover: '#484848',
    ctaBgActive: '#5b5b5b',
    ctaBorder: '#2e2e2e',
  },
};

export const SURFACE_SCOPES_DARK_HEX: SurfaceScopes = {
  '0': {
    fg: '#e5e5e5',
    fgSecondary: '#a3a3a3',
    fgTertiary: '#808080',
    fgDisabled: '#5d5d5d',
    inputBg: '#292929',
    inputBorder: '#383838',
    inputBorderHover: '#474747',
    inputBorderFocus: '#565656',
    inputBorderError: '#cf2f2f',
    inputBorderActive: '#525252',
    inputBorderHighlight: '#4c4c4c',
    inputBgActive: '#303030',
    inputBgHighlight: '#2e2e2e',
    inputBgDisabled: '#1a1a1a',
    inputPlaceholder: '#7a7a7a',
    tabBg: '#2e2e2e',
    tabBgHover: '#383838',
    tabOutline: '#474747',
    borderSubtle: '#333333',
    borderDefault: '#404040',
    ctaBg: '#fafafa',
    ctaFg: '#0a0a0a',
    ctaBgHover: '#dedede',
    ctaBgActive: '#c4c4c4',
    ctaBorder: '#fafafa',
  },
  '1': {
    fg: '#e5e5e5',
    fgSecondary: '#a3a3a3',
    fgTertiary: '#808080',
    fgDisabled: '#5d5d5d',
    inputBg: '#2e2e2e',
    inputBorder: '#3d3d3d',
    inputBorderHover: '#4c4c4c',
    inputBorderFocus: '#5c5c5c',
    inputBorderError: '#cf2f2f',
    inputBorderActive: '#575757',
    inputBorderHighlight: '#525252',
    inputBgActive: '#363636',
    inputBgHighlight: '#333333',
    inputBgDisabled: '#1f1f1f',
    inputPlaceholder: '#7a7a7a',
    tabBg: '#333333',
    tabBgHover: '#3d3d3d',
    tabOutline: '#4a4a4a',
    borderSubtle: '#383838',
    borderDefault: '#454545',
    ctaBg: '#eeeeee',
    ctaFg: '#0a0a0a',
    ctaBgHover: '#d4d4d4',
    ctaBgActive: '#bababa',
    ctaBorder: '#eeeeee',
  },
  '2': {
    fg: '#e5e5e5',
    fgSecondary: '#a3a3a3',
    fgTertiary: '#808080',
    fgDisabled: '#5d5d5d',
    inputBg: '#383838',
    inputBorder: '#474747',
    inputBorderHover: '#575757',
    inputBorderFocus: '#666666',
    inputBorderError: '#cf2f2f',
    inputBorderActive: '#616161',
    inputBorderHighlight: '#5c5c5c',
    inputBgActive: '#404040',
    inputBgHighlight: '#3d3d3d',
    inputBgDisabled: '#292929',
    inputPlaceholder: '#7a7a7a',
    tabBg: '#3d3d3d',
    tabBgHover: '#474747',
    tabOutline: '#4c4c4c',
    borderSubtle: '#424242',
    borderDefault: '#4c4c4c',
    ctaBg: '#e1e1e1',
    ctaFg: '#0a0a0a',
    ctaBgHover: '#c7c7c7',
    ctaBgActive: '#aeaeae',
    ctaBorder: '#e1e1e1',
  },
  '3': {
    fg: '#e5e5e5',
    fgSecondary: '#a3a3a3',
    fgTertiary: '#808080',
    fgDisabled: '#5d5d5d',
    inputBg: '#333333',
    inputBorder: '#424242',
    inputBorderHover: '#525252',
    inputBorderFocus: '#616161',
    inputBorderError: '#cf2f2f',
    inputBorderActive: '#5c5c5c',
    inputBorderHighlight: '#575757',
    inputBgActive: '#3b3b3b',
    inputBgHighlight: '#383838',
    inputBgDisabled: '#242424',
    inputPlaceholder: '#7a7a7a',
    tabBg: '#383838',
    tabBgHover: '#424242',
    tabOutline: '#474747',
    borderSubtle: '#3d3d3d',
    borderDefault: '#474747',
    ctaBg: '#d4d4d4',
    ctaFg: '#0a0a0a',
    ctaBgHover: '#bababa',
    ctaBgActive: '#a1a1a1',
    ctaBorder: '#d4d4d4',
  },
  '4': {
    fg: '#e5e5e5',
    fgSecondary: '#a3a3a3',
    fgTertiary: '#808080',
    fgDisabled: '#5d5d5d',
    inputBg: '#3d3d3d',
    inputBorder: '#4c4c4c',
    inputBorderHover: '#5c5c5c',
    inputBorderFocus: '#6b6b6b',
    inputBorderError: '#cf2f2f',
    inputBorderActive: '#666666',
    inputBorderHighlight: '#616161',
    inputBgActive: '#454545',
    inputBgHighlight: '#424242',
    inputBgDisabled: '#2e2e2e',
    inputPlaceholder: '#7a7a7a',
    tabBg: '#424242',
    tabBgHover: '#4c4c4c',
    tabOutline: '#525252',
    borderSubtle: '#474747',
    borderDefault: '#525252',
    ctaBg: '#c7c7c7',
    ctaFg: '#0a0a0a',
    ctaBgHover: '#aeaeae',
    ctaBgActive: '#959595',
    ctaBorder: '#c7c7c7',
  },
};

export const PRESET_OVERRIDES_HEX: Record<ThemePresetId, {
  light?: Partial<ThemePresetColors>;
  dark?: Partial<ThemePresetColors>;
  surfaceScopesLight?: SurfaceScopes;
  surfaceScopesDark?: SurfaceScopes;
}> = {
  default: {},

  ocean: {
    light: {
      surface0: '#071c2e',
      surface0Hover: '#0e263b',
      surface0Active: '#153048',
      surface0Highlight: '#122b41',
      surface1: '#ffffff',
      surface1Hover: '#f0f5fa',
      surface1Active: '#e4edf6',
      surface1Highlight: '#ecf2f9',
      surface2: '#e6e8ea',
      surface2Hover: '#ebedef',
      surface2Active: '#e0e3e6',
      surface2Highlight: '#e5e8ec',
      surface3: '#ffffff',
      surface3Hover: '#f7f7f8',
      surface3Active: '#eef0f1',
      surface3Highlight: '#f3f5f6',
      surface4: '#f8fafc',
      surface4Hover: '#f1f4f6',
      surface4Active: '#eaedf0',
      surface4Highlight: '#eff2f6',
      accent: '#e0f0ff',
      accentForeground: '#00407f',
      accentHover: '#c2e1ff',
      sidebarAccent: '#3772bb',
      sidebarAccentForeground: '#ffffff',
      sidebarHover: '#102b43',
      borderSubtle: '#dbdee1',
      borderDefault: '#c7ccd1',
      borderMainContent: '#d8dce0',
      inputBg: '#ffffff',
      inputBorder: '#dbdee1',
      inputBorderHover: '#c6ccd2',
      inputBorderFocus: '#007fff',
      inputBorderActive: '#b8bfc7',
      inputBorderHighlight: '#c4ccd4',
      inputBgActive: '#f7f7f8',
      inputBgHighlight: '#f6f7f9',
      inputBgDisabled: '#f4f5f6',
      inputPlaceholder: '#898f95',
      tabBg: '#e0e3e6',
      tabBgHover: '#d8dbdf',
      tabOutline: '#c2c7cb',
      background: '#071c2e',
      panelBackground: '#ffffff',
      mainPanelBackground: '#ffffff',
      ring: '#0080fe',
      contentPreviewBg: '#e2e9f0',
      contentPreviewFg: '#44586b',
      contentPreviewBorder: '#c8d2dd',
    },
    dark: {
      surface0: '#050d15',
      surface0Hover: '#081421',
      surface0Active: '#0b1c2d',
      surface0Highlight: '#091725',
      surface1: '#0a141f',
      surface1Hover: '#0e1c2a',
      surface1Active: '#122436',
      surface1Highlight: '#0f1f2e',
      surface2: '#252e3a',
      surface2Hover: '#2f3844',
      surface2Active: '#36404c',
      surface2Highlight: '#313b47',
      surface3: '#252a31',
      surface3Hover: '#2d333a',
      surface3Active: '#353b42',
      surface3Highlight: '#30353d',
      surface4: '#303235',
      surface4Hover: '#3a3c3f',
      surface4Active: '#424447',
      surface4Highlight: '#3d3f42',
      accent: '#061f37',
      accentForeground: '#cce6ff',
      accentHover: '#092e53',
      sidebarAccent: '#3d78c2',
      sidebarAccentForeground: '#ffffff',
      sidebarHover: '#0a1a29',
      borderSubtle: '#2d3339',
      borderDefault: '#384047',
      borderMainContent: '#2e353c',
      inputBg: '#22262b',
      inputBorder: '#31383f',
      inputBorderHover: '#3d4752',
      inputBorderFocus: '#0073e6',
      inputBorderActive: '#45525e',
      inputBorderHighlight: '#414d58',
      inputBgActive: '#282e34',
      inputBgHighlight: '#262b31',
      inputBgDisabled: '#1e2124',
      inputPlaceholder: '#737a82',
      tabBg: '#292e32',
      tabBgHover: '#32383e',
      tabOutline: '#454c54',
      background: '#050d15',
      panelBackground: '#0a141f',
      mainPanelBackground: '#0a141f',
      ring: '#0073e8',
      contentPreviewBg: '#161f28',
      contentPreviewFg: '#93a0ae',
      contentPreviewBorder: '#2c343c',
    },
    surfaceScopesLight: {
      '0': {
        fg: '#e5e5e5',
        fgSecondary: '#a3a3a3',
        fgTertiary: '#808080',
        fgDisabled: '#5d5d5d',
        inputBg: '#ffffff',
        inputBorder: '#d5d9dd',
        inputBorderHover: '#c0c7ce',
        inputBorderFocus: '#c0c7ce',
        inputBorderError: '#ef4343',
        inputBorderActive: '#b2bac2',
        inputBorderHighlight: '#bec7cf',
        inputBgActive: '#f7f7f8',
        inputBgHighlight: '#f6f7f9',
        inputBgDisabled: '#f1f2f3',
        inputPlaceholder: '#898f95',
        tabBg: '#e0e3e6',
        tabBgHover: '#d8dbdf',
        tabOutline: '#c2c7cb',
        borderSubtle: '#dbdee1',
        borderDefault: '#c7ccd1',
      },
      '1': {
        inputBg: '#ffffff',
        inputBorder: '#d5d9dd',
        inputBorderHover: '#c0c7ce',
        inputBorderFocus: '#c0c7ce',
        inputBorderError: '#ef4343',
        inputBorderActive: '#b2bac2',
        inputBorderHighlight: '#bec7cf',
        inputBgActive: '#f7f7f8',
        inputBgHighlight: '#f6f7f9',
        inputBgDisabled: '#f1f2f3',
        inputPlaceholder: '#898f95',
        tabBg: '#e0e3e6',
        tabBgHover: '#d8dbdf',
        tabOutline: '#c2c7cb',
        borderSubtle: '#dbdee1',
        borderDefault: '#c7ccd1',
      },
      '2': {
        inputBg: '#fcfcfd',
        inputBorder: '#d2d6da',
        inputBorderHover: '#bdc4cb',
        inputBorderFocus: '#bdc4cb',
        inputBorderError: '#ef4343',
        inputBorderActive: '#afb8c0',
        inputBorderHighlight: '#bbc4cd',
        inputBgActive: '#f4f5f6',
        inputBgHighlight: '#f3f5f6',
        inputBgDisabled: '#eff0f1',
        inputPlaceholder: '#898f95',
        tabBg: '#dbdee1',
        tabBgHover: '#d3d6d9',
        tabOutline: '#c2c7cb',
        borderSubtle: '#d8dbdf',
        borderDefault: '#c4cacf',
      },
      '3': {
        inputBg: '#f4f5f6',
        inputBorder: '#cdd1d6',
        inputBorderHover: '#b8bfc7',
        inputBorderFocus: '#b8bfc7',
        inputBorderError: '#ef4343',
        inputBorderActive: '#a9b3bc',
        inputBorderHighlight: '#b6bfc9',
        inputBgActive: '#ecedef',
        inputBgHighlight: '#edf0f2',
        inputBgDisabled: '#ecedef',
        inputPlaceholder: '#898f95',
        tabBg: '#eff0f1',
        tabBgHover: '#e6e8ea',
        tabOutline: '#c2c7cb',
        borderSubtle: '#d5d9dd',
        borderDefault: '#c1c7cd',
      },
      '4': {
        inputBg: '#f4f5f6',
        inputBorder: '#cdd1d6',
        inputBorderHover: '#b8bfc7',
        inputBorderFocus: '#b8bfc7',
        inputBorderError: '#ef4343',
        inputBorderActive: '#a9b3bc',
        inputBorderHighlight: '#b6bfc9',
        inputBgActive: '#ecedef',
        inputBgHighlight: '#edf0f2',
        inputBgDisabled: '#ecedef',
        inputPlaceholder: '#898f95',
        tabBg: '#eff0f1',
        tabBgHover: '#e6e8ea',
        tabOutline: '#c2c7cb',
        borderSubtle: '#d5d9dd',
        borderDefault: '#c1c7cd',
      },
    },
    surfaceScopesDark: {
      '0': {
        inputBg: '#14171a',
        inputBorder: '#24292e',
        inputBorderHover: '#303841',
        inputBorderFocus: '#303841',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#38424c',
        inputBorderHighlight: '#343d46',
        inputBgActive: '#1b1f22',
        inputBgHighlight: '#191c20',
        inputBgDisabled: '#101214',
        inputPlaceholder: '#737a82',
        tabBg: '#191c1f',
        tabBgHover: '#22262a',
        tabOutline: '#32383e',
        borderSubtle: '#1d2125',
        borderDefault: '#282e34',
      },
      '1': {
        inputBg: '#1b1f22',
        inputBorder: '#282e34',
        inputBorderHover: '#343d46',
        inputBorderFocus: '#343d46',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#3d4752',
        inputBorderHighlight: '#38424c',
        inputBgActive: '#22262b',
        inputBgHighlight: '#202428',
        inputBgDisabled: '#171a1c',
        inputPlaceholder: '#737a82',
        tabBg: '#202427',
        tabBgHover: '#292e32',
        tabOutline: '#373d43',
        borderSubtle: '#24292e',
        borderDefault: '#2f363c',
      },
      '2': {
        inputBg: '#31383f',
        inputBorder: '#3f4750',
        inputBorderHover: '#4a5764',
        inputBorderFocus: '#4a5764',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#52616f',
        inputBorderHighlight: '#4e5c6a',
        inputBgActive: '#384047',
        inputBgHighlight: '#363d45',
        inputBgDisabled: '#25292d',
        inputPlaceholder: '#737a82',
        tabBg: '#373d43',
        tabBgHover: '#40484f',
        tabOutline: '#454c54',
        borderSubtle: '#3a424a',
        borderDefault: '#434d56',
      },
      '3': {
        inputBg: '#2d3339',
        inputBorder: '#3a424a',
        inputBorderHover: '#45525e',
        inputBorderFocus: '#45525e',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#4e5c6a',
        inputBorderHighlight: '#4a5764',
        inputBgActive: '#343b42',
        inputBgHighlight: '#31383f',
        inputBgDisabled: '#202427',
        inputPlaceholder: '#737a82',
        tabBg: '#32383e',
        tabBgHover: '#3c4249',
        tabOutline: '#40484f',
        borderSubtle: '#363d45',
        borderDefault: '#3f4750',
      },
      '4': {
        inputBg: '#363d45',
        inputBorder: '#434d56',
        inputBorderHover: '#4e5c6a',
        inputBorderFocus: '#4e5c6a',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#576675',
        inputBorderHighlight: '#52616f',
        inputBgActive: '#3d454d',
        inputBgHighlight: '#3a424a',
        inputBgDisabled: '#292e32',
        inputPlaceholder: '#737a82',
        tabBg: '#3c4249',
        tabBgHover: '#454c54',
        tabOutline: '#49525a',
        borderSubtle: '#3f4750',
        borderDefault: '#48525b',
      },
    },
  },

  forest: {
    light: {
      surface0: '#042112',
      surface0Hover: '#0a2b1a',
      surface0Active: '#113623',
      surface0Highlight: '#0e301f',
      surface1: '#ffffff',
      surface1Hover: '#f1f9f4',
      surface1Active: '#e6f4eb',
      surface1Highlight: '#edf7f1',
      surface2: '#e6eae8',
      surface2Hover: '#ecefed',
      surface2Active: '#e0e6e2',
      surface2Highlight: '#e5ebe7',
      surface3: '#ffffff',
      surface3Hover: '#f7f8f7',
      surface3Active: '#eef1ef',
      surface3Highlight: '#f3f6f4',
      surface4: '#f9fbf9',
      surface4Hover: '#f1f4f2',
      surface4Active: '#eaeeeb',
      surface4Highlight: '#eff3f0',
      accent: '#e0f5e8',
      accentForeground: '#105729',
      accentHover: '#c6ecd4',
      sidebarAccent: '#00713e',
      sidebarAccentForeground: '#ffffff',
      sidebarHover: '#0b311e',
      borderSubtle: '#dbe1dd',
      borderDefault: '#c7d1cb',
      borderMainContent: '#d7dfda',
      inputBg: '#ffffff',
      inputBorder: '#dbe1dd',
      inputBorderHover: '#c6d2cb',
      inputBorderFocus: '#1aab51',
      inputBorderActive: '#b8c7bd',
      inputBorderHighlight: '#c4d3ca',
      inputBgActive: '#f7f8f7',
      inputBgHighlight: '#f6f8f7',
      inputBgDisabled: '#f4f5f4',
      inputPlaceholder: '#89958d',
      tabBg: '#e0e6e2',
      tabBgHover: '#d8dfdb',
      tabOutline: '#c3cbc6',
      background: '#042112',
      panelBackground: '#ffffff',
      mainPanelBackground: '#ffffff',
      ring: '#00b15a',
      contentPreviewBg: '#e2eae5',
      contentPreviewFg: '#425c4d',
      contentPreviewBorder: '#c8d5cc',
    },
    dark: {
      surface0: '#050f09',
      surface0Hover: '#091b10',
      surface0Active: '#0d2616',
      surface0Highlight: '#0a1f12',
      surface1: '#0b1910',
      surface1Hover: '#0f2417',
      surface1Active: '#142e1e',
      surface1Highlight: '#112719',
      surface2: '#27332b',
      surface2Hover: '#313e35',
      surface2Active: '#39463d',
      surface2Highlight: '#344138',
      surface3: '#272e29',
      surface3Hover: '#303732',
      surface3Active: '#383f3a',
      surface3Highlight: '#333a35',
      surface4: '#333634',
      surface4Hover: '#3e403f',
      surface4Active: '#464947',
      surface4Highlight: '#414341',
      accent: '#0f2417',
      accentForeground: '#c2f0d3',
      accentHover: '#193925',
      sidebarAccent: '#00713e',
      sidebarAccentForeground: '#ffffff',
      sidebarHover: '#0c1d12',
      borderSubtle: '#2d3931',
      borderDefault: '#38473e',
      borderMainContent: '#2e3b33',
      inputBg: '#222b25',
      inputBorder: '#313f36',
      inputBorderHover: '#3d5245',
      inputBorderFocus: '#248f4b',
      inputBorderActive: '#455e4e',
      inputBorderHighlight: '#415849',
      inputBgActive: '#28332c',
      inputBgHighlight: '#26302a',
      inputBgDisabled: '#1e2420',
      inputPlaceholder: '#738278',
      tabBg: '#29322d',
      tabBgHover: '#323e37',
      tabOutline: '#45544a',
      background: '#050f09',
      panelBackground: '#0b1910',
      mainPanelBackground: '#0b1910',
      ring: '#009448',
      contentPreviewBg: '#142219',
      contentPreviewFg: '#90a496',
      contentPreviewBorder: '#29372d',
    },
    surfaceScopesLight: {
      '0': {
        fg: '#e5e5e5',
        fgSecondary: '#a3a3a3',
        fgTertiary: '#808080',
        fgDisabled: '#5d5d5d',
        inputBg: '#ffffff',
        inputBorder: '#d5ddd8',
        inputBorderHover: '#c0cec5',
        inputBorderFocus: '#c0cec5',
        inputBorderError: '#ef4343',
        inputBorderActive: '#b2c3b8',
        inputBorderHighlight: '#bfcfc5',
        inputBgActive: '#f7f8f7',
        inputBgHighlight: '#f6f8f7',
        inputBgDisabled: '#f1f3f2',
        inputPlaceholder: '#89958d',
        tabBg: '#e0e6e2',
        tabBgHover: '#d8dfdb',
        tabOutline: '#c3cbc6',
        borderSubtle: '#dbe1dd',
        borderDefault: '#c7d1cb',
      },
      '1': {
        inputBg: '#ffffff',
        inputBorder: '#d5ddd8',
        inputBorderHover: '#c0cec5',
        inputBorderFocus: '#c0cec5',
        inputBorderError: '#ef4343',
        inputBorderActive: '#b2c3b8',
        inputBorderHighlight: '#bfcfc5',
        inputBgActive: '#f7f8f7',
        inputBgHighlight: '#f6f8f7',
        inputBgDisabled: '#f1f3f2',
        inputPlaceholder: '#89958d',
        tabBg: '#e0e6e2',
        tabBgHover: '#d8dfdb',
        tabOutline: '#c3cbc6',
        borderSubtle: '#dbe1dd',
        borderDefault: '#c7d1cb',
      },
      '2': {
        inputBg: '#fcfdfc',
        inputBorder: '#d2dad5',
        inputBorderHover: '#bdcbc2',
        inputBorderFocus: '#bdcbc2',
        inputBorderError: '#ef4343',
        inputBorderActive: '#afc0b5',
        inputBorderHighlight: '#bbcdc2',
        inputBgActive: '#f4f5f4',
        inputBgHighlight: '#f3f6f4',
        inputBgDisabled: '#eff1f0',
        inputPlaceholder: '#89958d',
        tabBg: '#dbe0dd',
        tabBgHover: '#d3dad5',
        tabOutline: '#c3cbc6',
        borderSubtle: '#d8dfdb',
        borderDefault: '#c4cfc8',
      },
      '3': {
        inputBg: '#f4f6f5',
        inputBorder: '#ccd6d0',
        inputBorderHover: '#b8c7bd',
        inputBorderFocus: '#b8c7bd',
        inputBorderError: '#ef4343',
        inputBorderActive: '#a9bcb0',
        inputBorderHighlight: '#b6c9bd',
        inputBgActive: '#ecefed',
        inputBgHighlight: '#edf2ef',
        inputBgDisabled: '#ecefed',
        inputPlaceholder: '#89958d',
        tabBg: '#eff1f0',
        tabBgHover: '#e6eae7',
        tabOutline: '#c3cbc6',
        borderSubtle: '#d5ddd8',
        borderDefault: '#c1ccc5',
      },
      '4': {
        inputBg: '#f4f6f5',
        inputBorder: '#ccd6d0',
        inputBorderHover: '#b8c7bd',
        inputBorderFocus: '#b8c7bd',
        inputBorderError: '#ef4343',
        inputBorderActive: '#a9bcb0',
        inputBorderHighlight: '#b6c9bd',
        inputBgActive: '#ecefed',
        inputBgHighlight: '#edf2ef',
        inputBgDisabled: '#ecefed',
        inputPlaceholder: '#89958d',
        tabBg: '#eff1f0',
        tabBgHover: '#e6eae7',
        tabOutline: '#c3cbc6',
        borderSubtle: '#d5ddd8',
        borderDefault: '#c1ccc5',
      },
    },
    surfaceScopesDark: {
      '0': {
        inputBg: '#121714',
        inputBorder: '#1f2822',
        inputBorderHover: '#2b3b31',
        inputBorderFocus: '#2b3b31',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#34463b',
        inputBorderHighlight: '#304036',
        inputBgActive: '#19201b',
        inputBgHighlight: '#161d19',
        inputBgDisabled: '#0e110f',
        inputPlaceholder: '#738278',
        tabBg: '#171c19',
        tabBgHover: '#202723',
        tabOutline: '#2e3832',
        borderSubtle: '#1b221e',
        borderDefault: '#26302a',
      },
      '1': {
        inputBg: '#19201b',
        inputBorder: '#26302a',
        inputBorderHover: '#324438',
        inputBorderFocus: '#324438',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#3b4f42',
        inputBorderHighlight: '#36493d',
        inputBgActive: '#1f2822',
        inputBgHighlight: '#1d2520',
        inputBgDisabled: '#151916',
        inputPlaceholder: '#738278',
        tabBg: '#1e2420',
        tabBgHover: '#27302a',
        tabOutline: '#354039',
        borderSubtle: '#222b25',
        borderDefault: '#2d3931',
      },
      '2': {
        inputBg: '#313f36',
        inputBorder: '#3f5045',
        inputBorderHover: '#4a6453',
        inputBorderFocus: '#4a6453',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#52705d',
        inputBorderHighlight: '#4e6a58',
        inputBgActive: '#38473e',
        inputBgHighlight: '#36453b',
        inputBgDisabled: '#252d28',
        inputPlaceholder: '#738278',
        tabBg: '#37433b',
        tabBgHover: '#404e45',
        tabOutline: '#45544a',
        borderSubtle: '#3a4a40',
        borderDefault: '#43564a',
      },
      '3': {
        inputBg: '#2d3931',
        inputBorder: '#3a4a40',
        inputBorderHover: '#455e4e',
        inputBorderFocus: '#455e4e',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#4e6a58',
        inputBorderHighlight: '#4a6453',
        inputBgActive: '#344239',
        inputBgHighlight: '#313f36',
        inputBgDisabled: '#202723',
        inputPlaceholder: '#738278',
        tabBg: '#323e37',
        tabBgHover: '#3c4941',
        tabOutline: '#404e45',
        borderSubtle: '#36453b',
        borderDefault: '#3f5045',
      },
      '4': {
        inputBg: '#36453b',
        inputBorder: '#43564a',
        inputBorderHover: '#4e6a58',
        inputBorderFocus: '#4e6a58',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#577562',
        inputBorderHighlight: '#52705d',
        inputBgActive: '#3d4d43',
        inputBgHighlight: '#3a4a40',
        inputBgDisabled: '#29322d',
        inputPlaceholder: '#738278',
        tabBg: '#3c4941',
        tabBgHover: '#45544a',
        tabOutline: '#4a5a50',
        borderSubtle: '#3f5045',
        borderDefault: '#485b4f',
      },
    },
  },

  berry: {
    light: {
      surface0: '#23132a',
      surface0Hover: '#2e1b36',
      surface0Active: '#392442',
      surface0Highlight: '#33203c',
      surface1: '#ffffff',
      surface1Hover: '#f6f0fa',
      surface1Active: '#f0e4f6',
      surface1Highlight: '#f4ecf9',
      surface2: '#e9e6ea',
      surface2Hover: '#eeebef',
      surface2Active: '#e4e0e6',
      surface2Highlight: '#e9e5eb',
      surface3: '#ffffff',
      surface3Hover: '#f8f7f8',
      surface3Active: '#f0eef1',
      surface3Highlight: '#f5f3f6',
      surface4: '#fafafc',
      surface4Hover: '#f4f3f6',
      surface4Active: '#edecf0',
      surface4Highlight: '#f2f1f5',
      accent: '#f4e3fc',
      accentForeground: '#610f8a',
      accentHover: '#e9c8f9',
      sidebarAccent: '#7955b0',
      sidebarAccentForeground: '#ffffff',
      sidebarHover: '#341f3d',
      borderSubtle: '#dfdae1',
      borderDefault: '#cec7d1',
      borderMainContent: '#ddd8e0',
      inputBg: '#ffffff',
      inputBorder: '#dfdae1',
      inputBorderHover: '#cec6d2',
      inputBorderFocus: '#a73cdd',
      inputBorderActive: '#c2b7c7',
      inputBorderHighlight: '#cec4d4',
      inputBgActive: '#f7f7f8',
      inputBgHighlight: '#f8f6f9',
      inputBgDisabled: '#f5f4f5',
      inputPlaceholder: '#918994',
      tabBg: '#e4e0e6',
      tabBgHover: '#dcd8df',
      tabOutline: '#c8c2cb',
      background: '#23132a',
      panelBackground: '#ffffff',
      mainPanelBackground: '#ffffff',
      ring: '#9347ed',
      contentPreviewBg: '#eae6ee',
      contentPreviewFg: '#5a5067',
      contentPreviewBorder: '#d3cedb',
    },
    dark: {
      surface0: '#0d0514',
      surface0Hover: '#140821',
      surface0Active: '#1c0b2d',
      surface0Highlight: '#170925',
      surface1: '#140a1f',
      surface1Hover: '#1c0e2a',
      surface1Active: '#241235',
      surface1Highlight: '#1f0f2e',
      surface2: '#2d2936',
      surface2Hover: '#373240',
      surface2Active: '#3e3a48',
      surface2Highlight: '#3a3543',
      surface3: '#29262e',
      surface3Hover: '#312f37',
      surface3Active: '#39363f',
      surface3Highlight: '#34313a',
      surface4: '#313033',
      surface4Hover: '#3a393c',
      surface4Active: '#424144',
      surface4Highlight: '#3d3c3f',
      accent: '#240f2e',
      accentForeground: '#ebd4f7',
      accentHover: '#361745',
      sidebarAccent: '#704fa2',
      sidebarAccentForeground: '#ffffff',
      sidebarHover: '#1e0d26',
      borderSubtle: '#332d39',
      borderDefault: '#403847',
      borderMainContent: '#352e3c',
      inputBg: '#26222b',
      inputBorder: '#38313f',
      inputBorderHover: '#483d52',
      inputBorderFocus: '#8a2eb7',
      inputBorderActive: '#52455e',
      inputBorderHighlight: '#4c4158',
      inputBgActive: '#2e2833',
      inputBgHighlight: '#2b2630',
      inputBgDisabled: '#211e25',
      inputPlaceholder: '#7a7382',
      tabBg: '#2e2932',
      tabBgHover: '#38323e',
      tabOutline: '#4c4554',
      background: '#0d0514',
      panelBackground: '#140a1f',
      mainPanelBackground: '#140a1f',
      ring: '#7937c6',
      contentPreviewBg: '#1d1228',
      contentPreviewFg: '#a498b3',
      contentPreviewBorder: '#33293e',
    },
    surfaceScopesLight: {
      '0': {
        fg: '#e5e5e5',
        fgSecondary: '#a3a3a3',
        fgTertiary: '#808080',
        fgDisabled: '#5d5d5d',
        inputBg: '#ffffff',
        inputBorder: '#dad5dd',
        inputBorderHover: '#c9c0ce',
        inputBorderFocus: '#c9c0ce',
        inputBorderError: '#ef4343',
        inputBorderActive: '#bdb2c2',
        inputBorderHighlight: '#cabecf',
        inputBgActive: '#f7f7f8',
        inputBgHighlight: '#f8f6f9',
        inputBgDisabled: '#f2f1f3',
        inputPlaceholder: '#918994',
        tabBg: '#e4e0e6',
        tabBgHover: '#dcd8df',
        tabOutline: '#c8c2cb',
        borderSubtle: '#dfdae1',
        borderDefault: '#cec7d1',
      },
      '1': {
        inputBg: '#ffffff',
        inputBorder: '#dad5dd',
        inputBorderHover: '#c9c0ce',
        inputBorderFocus: '#c9c0ce',
        inputBorderError: '#ef4343',
        inputBorderActive: '#bdb2c2',
        inputBorderHighlight: '#cabecf',
        inputBgActive: '#f7f7f8',
        inputBgHighlight: '#f8f6f9',
        inputBgDisabled: '#f2f1f3',
        inputPlaceholder: '#918994',
        tabBg: '#e4e0e6',
        tabBgHover: '#dcd8df',
        tabOutline: '#c8c2cb',
        borderSubtle: '#dfdae1',
        borderDefault: '#cec7d1',
      },
      '2': {
        inputBg: '#fdfcfd',
        inputBorder: '#d8d2da',
        inputBorderHover: '#c7bdcb',
        inputBorderFocus: '#c7bdcb',
        inputBorderError: '#ef4343',
        inputBorderActive: '#baafc0',
        inputBorderHighlight: '#c7bccd',
        inputBgActive: '#f5f4f5',
        inputBgHighlight: '#f5f3f6',
        inputBgDisabled: '#f0eef1',
        inputPlaceholder: '#918994',
        tabBg: '#dfdbe0',
        tabBgHover: '#d7d3d9',
        tabOutline: '#c8c2cb',
        borderSubtle: '#dcd8df',
        borderDefault: '#cbc4cf',
      },
      '3': {
        inputBg: '#f5f4f6',
        inputBorder: '#d3ccd6',
        inputBorderHover: '#c2b7c7',
        inputBorderFocus: '#c2b7c7',
        inputBorderActive: '#b6a9bc',
        inputBorderHighlight: '#c3b6c9',
        inputBorderError: '#ef4343',
        inputBgActive: '#eeecef',
        inputBgHighlight: '#f0edf2',
        inputBgDisabled: '#eeecef',
        inputPlaceholder: '#918994',
        tabBg: '#f0eef1',
        tabBgHover: '#e9e6ea',
        tabOutline: '#c8c2cb',
        borderSubtle: '#dad5dd',
        borderDefault: '#c9c1cc',
      },
      '4': {
        inputBg: '#f5f4f6',
        inputBorder: '#d3ccd6',
        inputBorderHover: '#c2b7c7',
        inputBorderFocus: '#c2b7c7',
        inputBorderActive: '#b6a9bc',
        inputBorderHighlight: '#c3b6c9',
        inputBorderError: '#ef4343',
        inputBgActive: '#eeecef',
        inputBgHighlight: '#f0edf2',
        inputBgDisabled: '#eeecef',
        inputPlaceholder: '#918994',
        tabBg: '#f0eef1',
        tabBgHover: '#e9e6ea',
        tabOutline: '#c8c2cb',
        borderSubtle: '#dad5dd',
        borderDefault: '#c9c1cc',
      },
    },
    surfaceScopesDark: {
      '0': {
        inputBg: '#17141a',
        inputBorder: '#29242e',
        inputBorderHover: '#383041',
        inputBorderFocus: '#383041',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#42384c',
        inputBorderHighlight: '#3d3446',
        inputBgActive: '#1f1b22',
        inputBgHighlight: '#1c191f',
        inputBgDisabled: '#121014',
        inputPlaceholder: '#7a7382',
        tabBg: '#1c191f',
        tabBgHover: '#26222a',
        tabOutline: '#38323e',
        borderSubtle: '#211d25',
        borderDefault: '#2e2833',
      },
      '1': {
        inputBg: '#1f1b22',
        inputBorder: '#2e2833',
        inputBorderHover: '#3d3446',
        inputBorderFocus: '#3d3446',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#483d52',
        inputBorderHighlight: '#42384c',
        inputBgActive: '#26222b',
        inputBgHighlight: '#242028',
        inputBgDisabled: '#1a171c',
        inputPlaceholder: '#7a7382',
        tabBg: '#242027',
        tabBgHover: '#2e2932',
        tabOutline: '#3d3743',
        borderSubtle: '#29242e',
        borderDefault: '#362f3c',
      },
      '2': {
        inputBg: '#38313f',
        inputBorder: '#473f50',
        inputBorderHover: '#574a64',
        inputBorderFocus: '#574a64',
        inputBorderActive: '#615370',
        inputBorderHighlight: '#5c4e69',
        inputBorderError: '#cf2f2f',
        inputBgActive: '#403847',
        inputBgHighlight: '#3d3645',
        inputBgDisabled: '#29252d',
        inputPlaceholder: '#7a7382',
        tabBg: '#3d3743',
        tabBgHover: '#47404f',
        tabOutline: '#4c4554',
        borderSubtle: '#423a4a',
        borderDefault: '#4c4356',
      },
      '3': {
        inputBg: '#332d39',
        inputBorder: '#423a4a',
        inputBorderHover: '#52455e',
        inputBorderFocus: '#52455e',
        inputBorderActive: '#5c4e69',
        inputBorderHighlight: '#574a64',
        inputBorderError: '#cf2f2f',
        inputBgActive: '#3b3442',
        inputBgHighlight: '#38313f',
        inputBgDisabled: '#242027',
        inputPlaceholder: '#7a7382',
        tabBg: '#38323e',
        tabBgHover: '#423c49',
        tabOutline: '#47404f',
        borderSubtle: '#3d3645',
        borderDefault: '#473f50',
      },
      '4': {
        inputBg: '#3d3645',
        inputBorder: '#4c4356',
        inputBorderHover: '#5c4e69',
        inputBorderFocus: '#5c4e69',
        inputBorderActive: '#665775',
        inputBorderHighlight: '#615370',
        inputBorderError: '#cf2f2f',
        inputBgActive: '#453c4d',
        inputBgHighlight: '#423a4a',
        inputBgDisabled: '#2e2932',
        inputPlaceholder: '#7a7382',
        tabBg: '#423c49',
        tabBgHover: '#4c4554',
        tabOutline: '#52495a',
        borderSubtle: '#473f50',
        borderDefault: '#52485b',
      },
    },
  },

  sand: {
    light: {
      surface0: '#eeebe7',
      surface0Hover: '#f1eadf',
      surface0Active: '#ede2d4',
      surface0Highlight: '#f0e7db',
      surface1: '#ffffff',
      surface1Hover: '#f6f3ee',
      surface1Active: '#f1ece5',
      surface1Highlight: '#f4f0eb',
      surface2: '#ebe8e5',
      surface2Hover: '#efedeb',
      surface2Active: '#e6e3df',
      surface2Highlight: '#ece9e4',
      surface3: '#ffffff',
      surface3Hover: '#f8f7f6',
      surface3Active: '#f2f0ed',
      surface3Highlight: '#f7f5f3',
      surface4: '#fcfaf8',
      surface4Hover: '#f5f3f1',
      surface4Active: '#efece9',
      surface4Highlight: '#f5f1ee',
      accent: '#f5ece0',
      accentForeground: '#4d3319',
      accentHover: '#eddeca',
      sidebarAccent: '#863f00',
      sidebarAccentForeground: '#ffffff',
      sidebarHover: '#f0e7db',
      borderSubtle: '#e0dcd7',
      borderDefault: '#cec8c0',
      borderMainContent: '#dedad3',
      inputBg: '#ffffff',
      inputBorder: '#e0dcd7',
      inputBorderHover: '#cfc8bf',
      inputBorderFocus: '#b27334',
      inputBorderActive: '#c4bcb1',
      inputBorderHighlight: '#d1c9bd',
      inputBgActive: '#f8f8f6',
      inputBgHighlight: '#f9f7f6',
      inputBgDisabled: '#f4f2f1',
      inputPlaceholder: '#958e83',
      tabBg: '#e4e1dd',
      tabBgHover: '#dbd7d1',
      tabOutline: '#c8c3bc',
      background: '#eeebe7',
      panelBackground: '#ffffff',
      mainPanelBackground: '#ffffff',
      ring: '#c26900',
      contentPreviewBg: '#e0deda',
      contentPreviewFg: '#58554e',
      contentPreviewBorder: '#d0cdc8',
    },
    dark: {
      surface0: '#160f09',
      surface0Hover: '#20170e',
      surface0Active: '#2b1f12',
      surface0Highlight: '#24190f',
      surface1: '#1e1710',
      surface1Hover: '#281f16',
      surface1Active: '#32261b',
      surface1Highlight: '#2b2117',
      surface2: '#362d26',
      surface2Hover: '#413830',
      surface2Active: '#494038',
      surface2Highlight: '#443a33',
      surface3: '#302a25',
      surface3Hover: '#39332e',
      surface3Active: '#413b36',
      surface3Highlight: '#3c3631',
      surface4: '#373431',
      surface4Hover: '#413e3c',
      surface4Active: '#494644',
      surface4Highlight: '#44413e',
      accent: '#352412',
      accentForeground: '#f3e4ce',
      accentHover: '#4d3319',
      sidebarAccent: '#823d00',
      sidebarAccentForeground: '#ffffff',
      sidebarHover: '#271c11',
      borderSubtle: '#3a332c',
      borderDefault: '#4c4239',
      borderMainContent: '#3d352c',
      inputBg: '#2c2621',
      inputBorder: '#403830',
      inputBorderHover: '#53483c',
      inputBorderFocus: '#a36629',
      inputBorderActive: '#5f5245',
      inputBorderHighlight: '#594d40',
      inputBgActive: '#342e28',
      inputBgHighlight: '#312b25',
      inputBgDisabled: '#25211d',
      inputPlaceholder: '#847a71',
      tabBg: '#332e28',
      tabBgHover: '#3f3831',
      tabOutline: '#564d43',
      background: '#160f09',
      panelBackground: '#1e1710',
      mainPanelBackground: '#1e1710',
      ring: '#b35b00',
      contentPreviewBg: '#271f16',
      contentPreviewFg: '#a89c90',
      contentPreviewBorder: '#3b3127',
    },
    surfaceScopesLight: {
      '0': {
        inputBg: '#ffffff',
        inputBorder: '#dbd7d1',
        inputBorderHover: '#cdc6bc',
        inputBorderFocus: '#cdc6bc',
        inputBorderError: '#ef4343',
        inputBorderActive: '#c2b9ae',
        inputBorderHighlight: '#cfc6ba',
        inputBgActive: '#f8f8f7',
        inputBgHighlight: '#f9f7f6',
        inputBgDisabled: '#f4f2f1',
        inputPlaceholder: '#958e83',
        tabBg: '#e4e1dd',
        tabBgHover: '#dbd7d1',
        tabOutline: '#c8c3bc',
        borderSubtle: '#e0dcd7',
        borderDefault: '#cec8c0',
      },
      '1': {
        inputBg: '#ffffff',
        inputBorder: '#dbd7d1',
        inputBorderHover: '#cdc6bc',
        inputBorderFocus: '#cdc6bc',
        inputBorderError: '#ef4343',
        inputBorderActive: '#c2b9ae',
        inputBorderHighlight: '#cfc6ba',
        inputBgActive: '#f8f8f7',
        inputBgHighlight: '#f9f7f6',
        inputBgDisabled: '#f4f2f1',
        inputPlaceholder: '#958e83',
        tabBg: '#e4e1dd',
        tabBgHover: '#dbd7d1',
        tabOutline: '#c8c3bc',
        borderSubtle: '#e0dcd7',
        borderDefault: '#cec8c0',
      },
      '2': {
        inputBg: '#fdfdfc',
        inputBorder: '#d9d4ce',
        inputBorderHover: '#cac3b9',
        inputBorderFocus: '#cac3b9',
        inputBorderError: '#ef4343',
        inputBorderActive: '#bfb7ab',
        inputBorderHighlight: '#cdc4b7',
        inputBgActive: '#f6f5f4',
        inputBgHighlight: '#f7f5f3',
        inputBgDisabled: '#f1f0ee',
        inputPlaceholder: '#958e83',
        tabBg: '#dfdcd8',
        tabBgHover: '#d8d5cf',
        tabOutline: '#c8c3bc',
        borderSubtle: '#ddd9d4',
        borderDefault: '#cbc5bd',
      },
      '3': {
        inputBg: '#f4f2f1',
        inputBorder: '#d4cfc9',
        inputBorderHover: '#c6beb4',
        inputBorderFocus: '#c6beb4',
        inputBorderError: '#ef4343',
        inputBorderActive: '#bbb2a5',
        inputBorderHighlight: '#c9bfb1',
        inputBgActive: '#edebe9',
        inputBgHighlight: '#f0eeea',
        inputBgDisabled: '#edebe9',
        inputPlaceholder: '#958e83',
        tabBg: '#efedeb',
        tabBgHover: '#e8e6e3',
        tabOutline: '#c8c3bc',
        borderSubtle: '#dbd7d1',
        borderDefault: '#c9c3bb',
      },
      '4': {
        inputBg: '#f4f2f1',
        inputBorder: '#d4cfc9',
        inputBorderHover: '#c6beb4',
        inputBorderFocus: '#c6beb4',
        inputBorderError: '#ef4343',
        inputBorderActive: '#bbb2a5',
        inputBorderHighlight: '#c9bfb1',
        inputBgActive: '#edebe9',
        inputBgHighlight: '#f0eeea',
        inputBgDisabled: '#edebe9',
        inputPlaceholder: '#958e83',
        tabBg: '#efedeb',
        tabBgHover: '#e8e6e3',
        tabOutline: '#c8c3bc',
        borderSubtle: '#dbd7d1',
        borderDefault: '#c9c3bb',
      },
    },
    surfaceScopesDark: {
      '0': {
        inputBg: '#1d1916',
        inputBorder: '#2e2923',
        inputBorderHover: '#41382f',
        inputBorderFocus: '#41382f',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#4d4238',
        inputBorderHighlight: '#473d33',
        inputBgActive: '#26211d',
        inputBgHighlight: '#231f1a',
        inputBgDisabled: '#171412',
        inputPlaceholder: '#847a71',
        tabBg: '#221f1b',
        tabBgHover: '#2e2924',
        tabOutline: '#3f3831',
        borderSubtle: '#29241f',
        borderDefault: '#37302a',
      },
      '1': {
        inputBg: '#26211d',
        inputBorder: '#37302a',
        inputBorderHover: '#4a4036',
        inputBorderFocus: '#4a4036',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#564a3e',
        inputBorderHighlight: '#50453a',
        inputBgActive: '#2e2923',
        inputBgHighlight: '#2c2621',
        inputBgDisabled: '#1f1c19',
        inputPlaceholder: '#847a71',
        tabBg: '#2b2622',
        tabBgHover: '#36302b',
        tabOutline: '#474038',
        borderSubtle: '#312b25',
        borderDefault: '#403830',
      },
      '2': {
        inputBg: '#403830',
        inputBorder: '#51473d',
        inputBorderHover: '#655749',
        inputBorderFocus: '#655749',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#706151',
        inputBorderHighlight: '#6a5c4d',
        inputBgActive: '#494037',
        inputBgHighlight: '#463d35',
        inputBgDisabled: '#2e2924',
        inputPlaceholder: '#847a71',
        tabBg: '#453d36',
        tabBgHover: '#50473f',
        tabOutline: '#564d43',
        borderSubtle: '#4c4239',
        borderDefault: '#574d42',
      },
      '3': {
        inputBg: '#3a332c',
        inputBorder: '#4c4239',
        inputBorderHover: '#5f5245',
        inputBorderFocus: '#5f5245',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#6a5c4d',
        inputBorderHighlight: '#655749',
        inputBgActive: '#433b32',
        inputBgHighlight: '#403830',
        inputBgDisabled: '#28241f',
        inputPlaceholder: '#847a71',
        tabBg: '#3f3831',
        tabBgHover: '#4a423a',
        tabOutline: '#50473f',
        borderSubtle: '#463d35',
        borderDefault: '#51473d',
      },
      '4': {
        inputBg: '#463d35',
        inputBorder: '#574d42',
        inputBorderHover: '#6a5c4d',
        inputBorderFocus: '#6a5c4d',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#766656',
        inputBorderHighlight: '#706151',
        inputBgActive: '#4f453b',
        inputBgHighlight: '#4c4239',
        inputBgDisabled: '#332e28',
        inputPlaceholder: '#847a71',
        tabBg: '#4a423a',
        tabBgHover: '#564d43',
        tabOutline: '#5b5248',
        borderSubtle: '#51473d',
        borderDefault: '#5d5246',
      },
    },
  },

  ayu: {
    light: {
      surface0: '#fcfcfd',
      surface0Hover: '#f3f5f7',
      surface0Active: '#eaedf1',
      surface0Highlight: '#f0f2f5',
      surface1: '#ffffff',
      surface1Hover: '#f0f2f4',
      surface1Active: '#e7ebee',
      surface1Highlight: '#edf0f2',
      surface2: '#e8eaed',
      surface2Hover: '#edf0f2',
      surface2Active: '#dfe3e7',
      surface2Highlight: '#e4e8ec',
      surface3: '#ffffff',
      surface3Hover: '#f7f7f8',
      surface3Active: '#eef0f1',
      surface3Highlight: '#f3f5f6',
      surface4: '#f8fafc',
      surface4Hover: '#f1f4f6',
      surface4Active: '#eaedf0',
      surface4Highlight: '#eff2f6',
      accent: '#fff0e0',
      accentForeground: '#aa4409',
      accentHover: '#ffe0c2',
      sidebarAccent: '#af6700',
      sidebarAccentForeground: '#ffffff',
      sidebarHover: '#f9f0e7',
      borderSubtle: '#dce0e5',
      borderDefault: '#c5ccd3',
      borderMainContent: '#d9dee4',
      inputBg: '#ffffff',
      inputBorder: '#dce0e5',
      inputBorderHover: '#c4ccd4',
      inputBorderFocus: '#e16600',
      inputBorderActive: '#b5bfca',
      inputBorderHighlight: '#c3ccd5',
      inputBgActive: '#f7f7f8',
      inputBgHighlight: '#f6f8f9',
      inputBgDisabled: '#f4f5f6',
      inputPlaceholder: '#888e96',
      tabBg: '#e2e6e9',
      tabBgHover: '#d6dbe0',
      tabOutline: '#c0c7ce',
      background: '#fcfcfd',
      panelBackground: '#ffffff',
      mainPanelBackground: '#ffffff',
      ring: '#ee9000',
      contentPreviewBg: '#e5e8eb',
      contentPreviewFg: '#4f565d',
      contentPreviewBorder: '#cdd1d6',
    },
    dark: {
      surface0: '#0b0e14',
      surface0Hover: '#10151e',
      surface0Active: '#151b28',
      surface0Highlight: '#121721',
      surface1: '#0f121a',
      surface1Hover: '#141924',
      surface1Active: '#1a202e',
      surface1Highlight: '#161c27',
      surface2: '#21272f',
      surface2Hover: '#2a3039',
      surface2Active: '#313841',
      surface2Highlight: '#2c333c',
      surface3: '#1e2227',
      surface3Hover: '#272b31',
      surface3Active: '#2e3338',
      surface3Highlight: '#2a2e34',
      surface4: '#292b2e',
      surface4Hover: '#333538',
      surface4Active: '#3a3c3f',
      surface4Highlight: '#35373a',
      accent: '#392b0e',
      accentForeground: '#f9d286',
      accentHover: '#513d14',
      sidebarAccent: '#ffa400',
      sidebarAccentForeground: '#0c121d',
      sidebarHover: '#161c27',
      borderSubtle: '#262b36',
      borderDefault: '#323a48',
      borderMainContent: '#272d39',
      inputBg: '#181c25',
      inputBorder: '#2a303c',
      inputBorderHover: '#394356',
      inputBorderFocus: '#b98500',
      inputBorderActive: '#414c62',
      inputBorderHighlight: '#3d475c',
      inputBgActive: '#1e242f',
      inputBgHighlight: '#1c212c',
      inputBgDisabled: '#14181f',
      inputPlaceholder: '#717784',
      tabBg: '#222630',
      tabBgHover: '#2a303c',
      tabOutline: '#3c4353',
      background: '#0b0e14',
      panelBackground: '#0f121a',
      mainPanelBackground: '#0f121a',
      ring: '#ffa400',
      contentPreviewBg: '#171c24',
      contentPreviewFg: '#979fad',
      contentPreviewBorder: '#2b303c',
    },
    surfaceScopesLight: {
      '0': {
        inputBg: '#ffffff',
        inputBorder: '#d6dbe0',
        inputBorderHover: '#bec7d0',
        inputBorderFocus: '#ff811a',
        inputBorderError: '#ef4343',
        inputBorderActive: '#afbac5',
        inputBorderHighlight: '#bdc7d1',
        inputBgActive: '#f7f7f8',
        inputBgHighlight: '#f6f8f9',
        inputBgDisabled: '#f1f2f4',
        inputPlaceholder: '#888e96',
        tabBg: '#e2e6e9',
        tabBgHover: '#d6dbe0',
        tabOutline: '#c0c7ce',
        borderSubtle: '#dce0e5',
        borderDefault: '#c5ccd3',
      },
      '1': {
        inputBg: '#ffffff',
        inputBorder: '#d6dbe0',
        inputBorderHover: '#bec7d0',
        inputBorderFocus: '#ff811a',
        inputBorderError: '#ef4343',
        inputBorderActive: '#afbac5',
        inputBorderHighlight: '#bdc7d1',
        inputBgActive: '#f7f7f8',
        inputBgHighlight: '#f6f8f9',
        inputBgDisabled: '#f1f2f4',
        inputPlaceholder: '#888e96',
        tabBg: '#e2e6e9',
        tabBgHover: '#d6dbe0',
        tabOutline: '#c0c7ce',
        borderSubtle: '#dce0e5',
        borderDefault: '#c5ccd3',
      },
      '2': {
        inputBg: '#fcfcfd',
        inputBorder: '#d1d6dc',
        inputBorderHover: '#bbc4ce',
        inputBorderFocus: '#ff811a',
        inputBorderError: '#ef4343',
        inputBorderActive: '#acb8c3',
        inputBorderHighlight: '#bac4cf',
        inputBgActive: '#f4f5f6',
        inputBgHighlight: '#f3f5f7',
        inputBgDisabled: '#eef0f1',
        inputPlaceholder: '#888e96',
        tabBg: '#dde0e4',
        tabBgHover: '#d4d9dd',
        tabOutline: '#c0c7ce',
        borderSubtle: '#d6dbe0',
        borderDefault: '#c2cad1',
      },
      '3': {
        inputBg: '#f3f5f6',
        inputBorder: '#ced4da',
        inputBorderHover: '#b8c2cc',
        inputBorderFocus: '#ff811a',
        inputBorderError: '#ef4343',
        inputBorderActive: '#a9b5c1',
        inputBorderHighlight: '#b7c2cd',
        inputBgActive: '#ebedef',
        inputBgHighlight: '#edf0f2',
        inputBgDisabled: '#ebedef',
        inputPlaceholder: '#888e96',
        tabBg: '#eef0f1',
        tabBgHover: '#e5e8eb',
        tabOutline: '#c0c7ce',
        borderSubtle: '#d6dbe0',
        borderDefault: '#bfc7cf',
      },
      '4': {
        inputBg: '#f3f5f6',
        inputBorder: '#ced4da',
        inputBorderHover: '#b8c2cc',
        inputBorderFocus: '#ff811a',
        inputBorderError: '#ef4343',
        inputBorderActive: '#a9b5c1',
        inputBorderHighlight: '#b7c2cd',
        inputBgActive: '#ebedef',
        inputBgHighlight: '#edf0f2',
        inputBgDisabled: '#ebedef',
        inputPlaceholder: '#888e96',
        tabBg: '#eef0f1',
        tabBgHover: '#e5e8eb',
        tabOutline: '#c0c7ce',
        borderSubtle: '#d6dbe0',
        borderDefault: '#bfc7cf',
      },
    },
    surfaceScopesDark: {
      '0': {
        inputBg: '#14181f',
        inputBorder: '#222630',
        inputBorderHover: '#2d3443',
        inputBorderFocus: '#ebb447',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#353e50',
        inputBorderHighlight: '#313949',
        inputBgActive: '#1a1f29',
        inputBgHighlight: '#181c25',
        inputBgDisabled: '#111318',
        inputPlaceholder: '#717784',
        tabBg: '#1a1d23',
        tabBgHover: '#22272f',
        tabOutline: '#2f3541',
        borderSubtle: '#1d222a',
        borderDefault: '#282e39',
      },
      '1': {
        inputBg: '#181c25',
        inputBorder: '#262b36',
        inputBorderHover: '#313949',
        inputBorderFocus: '#ebb447',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#394356',
        inputBorderHighlight: '#353e50',
        inputBgActive: '#1e242f',
        inputBgHighlight: '#1c212c',
        inputBgDisabled: '#15181e',
        inputPlaceholder: '#717784',
        tabBg: '#1e222a',
        tabBgHover: '#262b35',
        tabOutline: '#343a47',
        borderSubtle: '#222630',
        borderDefault: '#2c323f',
      },
      '2': {
        inputBg: '#29303d',
        inputBorder: '#363e4e',
        inputBorderHover: '#414c62',
        inputBorderFocus: '#ebb447',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#49566e',
        inputBorderHighlight: '#455168',
        inputBgActive: '#2f3746',
        inputBgHighlight: '#2d3443',
        inputBgDisabled: '#1d222a',
        inputPlaceholder: '#717784',
        tabBg: '#2f3541',
        tabBgHover: '#383f4d',
        tabOutline: '#404859',
        borderSubtle: '#323a48',
        borderDefault: '#3b4354',
      },
      '3': {
        inputBg: '#252b37',
        inputBorder: '#323a48',
        inputBorderHover: '#3d475c',
        inputBorderFocus: '#ebb447',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#455168',
        inputBorderHighlight: '#414c62',
        inputBgActive: '#2b3240',
        inputBgHighlight: '#29303d',
        inputBgDisabled: '#191d24',
        inputPlaceholder: '#717784',
        tabBg: '#2b303b',
        tabBgHover: '#343a47',
        tabOutline: '#3c4353',
        borderSubtle: '#2e3542',
        borderDefault: '#363e4e',
      },
      '4': {
        inputBg: '#2d3443',
        inputBorder: '#3b4354',
        inputBorderHover: '#455168',
        inputBorderFocus: '#ebb447',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#4e5b74',
        inputBorderHighlight: '#49566e',
        inputBgActive: '#333c4d',
        inputBgHighlight: '#313949',
        inputBgDisabled: '#222630',
        inputPlaceholder: '#717784',
        tabBg: '#343a47',
        tabBgHover: '#3c4353',
        tabOutline: '#444d5f',
        borderSubtle: '#363e4e',
        borderDefault: '#3f485a',
      },
    },
  },

  doodles: {
    dark: {
      surface0: '#1a1a1a',
      surface0Hover: '#212121',
      surface1: '#1a1a1a',
      surface1Hover: '#212121',
      contentPreviewBg: '#333333',
      contentPreviewFg: '#a3a3a3',
      contentPreviewBorder: '#404040',
    },
  },

  black: {
    dark: {
      surface0: '#070707',
      surface0Hover: '#0d0d0d',
      surface0Active: '#141414',
      surface0Highlight: '#0f0f0f',
      surface1: '#0f0f11',
      surface1Hover: '#151518',
      surface1Active: '#1d1d20',
      surface1Highlight: '#18181b',
      surface2: '#171717',
      surface2Hover: '#212121',
      surface2Active: '#292929',
      surface2Highlight: '#242424',
      surface3: '#141415',
      surface3Hover: '#1b1b1d',
      surface3Active: '#222225',
      surface3Highlight: '#1d1d20',
      surface4: '#1f1f1f',
      surface4Hover: '#262626',
      surface4Active: '#2e2e2e',
      surface4Highlight: '#292929',
      fg: '#d9d9d9',
      fgSecondary: '#8c8c8c',
      fgTertiary: '#6b6b6b',
      fgDisabled: '#474747',
      borderSubtle: '#1f1f1f',
      borderDefault: '#2e2e2e',
      borderMainContent: '#191919',
      accent: '#121212',
      accentForeground: '#e5e5e5',
      accentHover: '#1c1c1c',
      sidebarAccent: '#121212',
      sidebarAccentForeground: '#e5e5e5',
      sidebarHover: '#0a0a0a',
      tabBg: '#171717',
      tabBgHover: '#212121',
      tabOutline: '#333333',
      inputBg: '#121212',
      inputBorder: '#242424',
      inputBorderHover: '#333333',
      inputBorderFocus: '#414141',
      inputBorderActive: '#3d3d3d',
      inputBorderHighlight: '#383838',
      inputBgActive: '#1a1a1a',
      inputBgHighlight: '#171717',
      inputBgDisabled: '#0d0d0d',
      inputPlaceholder: '#6b6b6b',
      background: '#070707',
      panelBackground: '#0b0b0c',
      mainPanelBackground: '#0f0f11',
      contentPreviewBg: '#121212',
      contentPreviewFg: '#9e9e9e',
      contentPreviewBorder: '#262626',
    },
    surfaceScopesDark: {
      '0': {
        inputBg: '#121212',
        inputBorder: '#1f1f1f',
        inputBorderHover: '#2e2e2e',
        inputBorderFocus: '#3c3c3c',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#383838',
        inputBorderHighlight: '#333333',
        inputBgActive: '#1a1a1a',
        inputBgHighlight: '#171717',
        inputBgDisabled: '#0a0a0a',
        inputPlaceholder: '#6b6b6b',
        tabBg: '#141414',
        tabBgHover: '#1f1f1f',
        tabOutline: '#2e2e2e',
        borderSubtle: '#1a1a1a',
        borderDefault: '#262626',
      },
      '1': {
        inputBg: '#1a1a1a',
        inputBorder: '#262626',
        inputBorderHover: '#363636',
        inputBorderFocus: '#444444',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#404040',
        inputBorderHighlight: '#3b3b3b',
        inputBgActive: '#212121',
        inputBgHighlight: '#1f1f1f',
        inputBgDisabled: '#0d0d0d',
        inputPlaceholder: '#6b6b6b',
        tabBg: '#1c1c1c',
        tabBgHover: '#262626',
        tabOutline: '#333333',
        borderSubtle: '#212121',
        borderDefault: '#2b2b2b',
      },
      '2': {
        inputBg: '#212121',
        inputBorder: '#2e2e2e',
        inputBorderHover: '#3d3d3d',
        inputBorderFocus: '#4c4c4c',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#474747',
        inputBorderHighlight: '#424242',
        inputBgActive: '#292929',
        inputBgHighlight: '#262626',
        inputBgDisabled: '#121212',
        inputPlaceholder: '#6b6b6b',
        tabBg: '#242424',
        tabBgHover: '#2e2e2e',
        tabOutline: '#383838',
        borderSubtle: '#292929',
        borderDefault: '#333333',
      },
      '3': {
        inputBg: '#1f1f1f',
        inputBorder: '#292929',
        inputBorderHover: '#383838',
        inputBorderFocus: '#464646',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#424242',
        inputBorderHighlight: '#3d3d3d',
        inputBgActive: '#262626',
        inputBgHighlight: '#242424',
        inputBgDisabled: '#0f0f0f',
        inputPlaceholder: '#6b6b6b',
        tabBg: '#212121',
        tabBgHover: '#2b2b2b',
        tabOutline: '#333333',
        borderSubtle: '#262626',
        borderDefault: '#2e2e2e',
      },
      '4': {
        inputBg: '#292929',
        inputBorder: '#383838',
        inputBorderHover: '#474747',
        inputBorderFocus: '#565656',
        inputBorderError: '#cf2f2f',
        inputBorderActive: '#525252',
        inputBorderHighlight: '#4c4c4c',
        inputBgActive: '#303030',
        inputBgHighlight: '#2e2e2e',
        inputBgDisabled: '#1a1a1a',
        inputPlaceholder: '#6b6b6b',
        tabBg: '#2e2e2e',
        tabBgHover: '#383838',
        tabOutline: '#424242',
        borderSubtle: '#333333',
        borderDefault: '#3d3d3d',
      },
    },
  },

  white: {
    light: {
      surface0: '#f2f2f2',
      surface0Hover: '#ebebeb',
      surface0Active: '#e3e3e3',
      surface0Highlight: '#e8e8e8',
      surface1: '#ffffff',
      surface1Hover: '#f7f7f7',
      surface1Active: '#f0f0f0',
      surface1Highlight: '#f5f5f5',
      surface2: '#f5f5f5',
      surface2Hover: '#f5f5f5',
      surface2Active: '#ededed',
      surface2Highlight: '#f2f2f2',
      surface3: '#ffffff',
      surface3Hover: '#f7f7f7',
      surface3Active: '#f0f0f0',
      surface3Highlight: '#f5f5f5',
      surface4: '#fcf9fa',
      surface4Hover: '#f6f2f3',
      surface4Active: '#f0ebed',
      surface4Highlight: '#f5f0f1',
      borderSubtle: '#e0e0e0',
      borderDefault: '#cccccc',
      borderMainContent: '#e6e6e6',
      accent: '#f5f5f5',
      accentForeground: '#171717',
      accentHover: '#e5e5e5',
      sidebarAccent: '#f5f5f5',
      sidebarAccentForeground: '#171717',
      sidebarHover: '#f2f2f2',
      tabBg: '#ededed',
      tabBgHover: '#e5e5e5',
      tabOutline: '#d1d1d1',
      inputBg: '#ffffff',
      inputBorder: '#e0e0e0',
      inputBorderHover: '#cccccc',
      inputBorderFocus: '#8f8f8f',
      inputBorderActive: '#bfbfbf',
      inputBorderHighlight: '#c7c7c7',
      inputBgActive: '#f7f7f7',
      inputBgHighlight: '#fafafa',
      inputBgDisabled: '#f5f5f5',
      inputPlaceholder: '#8f8f8f',
      background: '#f2f2f2',
      panelBackground: '#ffffff',
      mainPanelBackground: '#ffffff',
      contentPreviewBg: '#e1e1e1',
      contentPreviewFg: '#555555',
      contentPreviewBorder: '#d1d1d1',
    },
    surfaceScopesLight: {
      '0': {
        inputBg: '#ffffff',
        inputBorder: '#dbdbdb',
        inputBorderHover: '#c7c7c7',
        inputBorderFocus: '#c7c7c7',
        inputBorderError: '#ef4343',
        inputBorderActive: '#bababa',
        inputBorderHighlight: '#c2c2c2',
        inputBgActive: '#f7f7f7',
        inputBgHighlight: '#fafafa',
        inputBgDisabled: '#f2f2f2',
        inputPlaceholder: '#8f8f8f',
        tabBg: '#e8e8e8',
        tabBgHover: '#e0e0e0',
        tabOutline: '#cccccc',
        borderSubtle: '#dedede',
        borderDefault: '#c9c9c9',
      },
      '1': {
        inputBg: '#f5f5f5',
        inputBorder: '#d9d9d9',
        inputBorderHover: '#c7c7c7',
        inputBorderFocus: '#c7c7c7',
        inputBorderError: '#ef4343',
        inputBorderActive: '#bababa',
        inputBorderHighlight: '#c2c2c2',
        inputBgActive: '#ededed',
        inputBgHighlight: '#f0f0f0',
        inputBgDisabled: '#ededed',
        inputPlaceholder: '#8f8f8f',
        tabBg: '#f0f0f0',
        tabBgHover: '#e8e8e8',
        tabOutline: '#cccccc',
        borderSubtle: '#dbdbdb',
        borderDefault: '#c7c7c7',
      },
      '2': {
        inputBg: '#fcfcfc',
        inputBorder: '#d9d9d9',
        inputBorderHover: '#c7c7c7',
        inputBorderFocus: '#c7c7c7',
        inputBorderError: '#ef4343',
        inputBorderActive: '#bababa',
        inputBorderHighlight: '#c2c2c2',
        inputBgActive: '#f5f5f5',
        inputBgHighlight: '#f7f7f7',
        inputBgDisabled: '#f0f0f0',
        inputPlaceholder: '#8f8f8f',
        tabBg: '#ededed',
        tabBgHover: '#e5e5e5',
        tabOutline: '#cccccc',
        borderSubtle: '#dbdbdb',
        borderDefault: '#c7c7c7',
      },
      '3': {
        inputBg: '#f5f5f5',
        inputBorder: '#d9d9d9',
        inputBorderHover: '#c7c7c7',
        inputBorderFocus: '#c7c7c7',
        inputBorderError: '#ef4343',
        inputBorderActive: '#bababa',
        inputBorderHighlight: '#c2c2c2',
        inputBgActive: '#ededed',
        inputBgHighlight: '#f0f0f0',
        inputBgDisabled: '#ededed',
        inputPlaceholder: '#8f8f8f',
        tabBg: '#f0f0f0',
        tabBgHover: '#e8e8e8',
        tabOutline: '#cccccc',
        borderSubtle: '#dbdbdb',
        borderDefault: '#c7c7c7',
      },
      '4': {
        inputBg: '#f5f5f5',
        inputBorder: '#d9d9d9',
        inputBorderHover: '#c7c7c7',
        inputBorderFocus: '#c7c7c7',
        inputBorderError: '#ef4343',
        inputBorderActive: '#bababa',
        inputBorderHighlight: '#c2c2c2',
        inputBgActive: '#ededed',
        inputBgHighlight: '#f0f0f0',
        inputBgDisabled: '#ededed',
        inputPlaceholder: '#8f8f8f',
        tabBg: '#f0f0f0',
        tabBgHover: '#e8e8e8',
        tabOutline: '#cccccc',
        borderSubtle: '#dbdbdb',
        borderDefault: '#c7c7c7',
      },
    },
  },

};

// ---------------------------------------------------------------------------
// Layout tokens — spacing & border-radius (px numbers for React Native)
// ---------------------------------------------------------------------------

export const SPACING_PX: ThemeSpacingNumeric = {
  spacing0: 0,
  spacing05: 4,
  spacing1: 8,
  spacing15: 12,
  spacing2: 16,
  spacing3: 24,
  spacing4: 32,
  spacing5: 40,
  spacing6: 48,
  spacing8: 64,
  spacing10: 80,
  spacing12: 96,
};

export const BORDER_RADIUS_PX: ThemeBorderRadiusNumeric = {
  radiusNone: 0,
  radiusSm: 4,
  radiusMd: 8,
  radiusLg: 12,
  radiusXl: 16,
  radius2xl: 24,
  radiusFull: 9999,
};
